module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAADxSURBVDhPlZI7DoJAEIb/FjvDTUzwOBbGI/jAt4UF3kCpTOiNEDpLD6ClxEIqaTQkWljiIEPYXSn0yzQ7Mx/MwCL5In7FztHhwxclQmPTQLskn6EWzvcz+kAXLbfFKRlVMGwDA2AK9HCJL5wVkAQ/8GmYtHsG0up2nQsCklCZVzD+dFOQ1oV38riWUwjW3kInf3wWI+gLncs5LETPCENgInRTfF5i7sysJ4OF6+Oa7vq7QJSOVLWqXM6Rltbm2h9LE+7JFT9rbVnjgoAkEMaq+HFhHHJWQBWCWwAzHaa5bXJKRhWI/y4fQdd7fVjzQSFJ3mquSHBH5LfaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/resource-node.png
// module id = 996
// module chunks = 0